import { PROVIDER, FACILITY } from 'constants/constants'
import PropTypes from 'prop-types'
import ActiveRecord from 'model/activeRecord'
import Member from 'model/person/member'
import { isNil } from 'ramda'
import { Roadmap_Status } from 'generated/types'

class RoadmapV2 extends ActiveRecord {
  constructor(init) {
    super(init)
    // console.log('> CarePlan constructor -', init)
    if (isNil(init)) return undefined
    this._archived = init.archived
    this._cost = init.cost
    this._member = new Member(init.member)
    this._description = init.description
    this._display_state = init.display_state
    this._first_time_visit = init.first_time_visit
    this._health_issue = init.health_issue
    this._introduction = init.introduction
    this._image = init.image
    this._performed_by = init.performed_by
    this._preferred_address = init.roadmap_preferred_address
    this._preferred_distance = init.preferred_distance
    this._provider_name = init.provider_name
    this._response_threshold = init.response_threshold
    this._special_needs = init.special_needs
    this._state = init.state
    this._suggested_doctors = init.suggested_doctors
    this._suggested_facilities = init.suggested_facilities
    this._title = init.title
    this._chat = init.chat
    this._request_notes = init.request_notes
  }

  static shape = {
    id: PropTypes.string,
    archived: PropTypes.bool,
    member: PropTypes.instanceOf(Member),
    description: PropTypes.string,
    display_state: PropTypes.string,
    first_time_visit: PropTypes.bool,
    health_issue: PropTypes.string,
    introduction: PropTypes.string,
    image: PropTypes.object,
    performed_by: PropTypes.string,
    preferred_address: PropTypes.string,
    preferred_distance: PropTypes.string,
    provider_name: PropTypes.string,
    response_threshold: PropTypes.string,
    special_needs: PropTypes.string,
    state: PropTypes.string,
    suggested_doctors: PropTypes.array,
    suggested_facilities: PropTypes.array,
    title: PropTypes.string,
    request_notes: PropTypes.string
  }

  // Getters and setters for class fields
  get archived() {
    return this._archived
  }

  get cost() {
    return this._cost
  }

  get member() {
    return this._member || {}
  }

  get first_time_visit() {
    return this._first_time_visit || false
  }

  get description() {
    return this._description || ''
  }

  get display_state() {
    return this._display_state || ''
  }

  get health_issue() {
    return this._health_issue || ''
  }

  get introduction() {
    return this._introduction || ''
  }

  get image() {
    return this._image
  }

  get performed_by() {
    return this._performed_by
  }

  get preferred_address() {
    return this._preferred_address
  }

  get preferred_distance() {
    return this._preferred_distance
  }

  get provider_name() {
    return this._provider_name || ''
  }

  get response_threshold() {
    return this._response_threshold || ''
  }

  get special_needs() {
    return this._special_needs || ''
  }

  get state() {
    return this._state
  }

  get suggested_doctors() {
    return this._suggested_doctors || []
  }

  get suggested_facilities() {
    return this._suggested_facilities || []
  }

  get title() {
    return this._title
  }

  get name() {
    return this._title
  }

  get chat() {
    return this._chat
  }

  get request_notes() {
    return this._request_notes || ''
  }

  // Calculable
  get isPendingState() {
    return this._state === Roadmap_Status.Pending
  }

  get isInProgressState() {
    return this._state === Roadmap_Status.InProgress
  }

  get isResolvedState() {
    return this._state === Roadmap_Status.Resolved
  }

  get shouldBlockReadyToClose() {
    return !this.isResolvedState && !this.archived
  }

  get isFacility() {
    return this._performed_by === FACILITY
  }

  get isProvider() {
    return this._performed_by === PROVIDER
  }
}

export default RoadmapV2
